import React, { useEffect, useRef } from 'react'
import ReactModal from 'react-modal'
import { isEmpty } from 'lodash'
import cn from 'classnames'

import { ReactComponent as CloseIcon } from '../../assets/icons/closeIcon.svg'

const Modal = ({ title, subtitle, onClose, children, className, anchor, getScrollPosition }) => {
  let subTitleElement = null
  const modalRef = useRef(null)

  useEffect(() => {
    if (anchor) {
      anchor.scrollIntoView(true)
    }
  }, [anchor])

  const modalElement = modalRef.current

  useEffect(() => {
    if (modalRef.current && getScrollPosition) {
      modalRef.current.addEventListener('scroll', () => {
        getScrollPosition(modalRef.current.scrollTop)
      })

      return () => {
        modalRef.current.removeEventListener('scroll', getScrollPosition)
      }
    }
  }, [getScrollPosition, modalElement])

  if (!isEmpty(subtitle)) {
    subTitleElement = (
      <div className="header-row">
        <h2>{subtitle}</h2>
      </div>
    )
  }

  return (
    <ReactModal
      isOpen
      className={cn('modal', className)}
      overlayClassName="modal-overlay"
      contentRef={node => (modalRef.current = node)}
    >
      <div className="header" ref={modalRef}>
        <div className="header-row">
          <h1>{title}</h1>
          <button className="close-icon" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        {subTitleElement}
      </div>
      {children}
    </ReactModal>
  )
}

export default Modal
